
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./immer.cjs.production.min.js')
} else {
  module.exports = require('./immer.cjs.development.js')
}



//////////////////
// WEBPACK FOOTER
// ./~/immer/dist/index.js
// module id = 79
// module chunks = 0